export const VEHICLE_FEATURES = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14'] as const;
export const VEHICLE_TYPES = ['1', '2', '3', '4'] as const;
